module.exports = __webpack_public_path__ + "static/img/mien.679a73ce.png";